<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>

      <div class="nav-item" :class="{active:type===0}" @click="isshow1 = !isshow1" >
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconshenhe"></i>
          </div>
        </div>
        业务账单
      </div>
      <div class="nat-item-two" v-show="type===0 || isshow1">
        <div :class="{active:type===0&&twoNav===0}" @click="toInfo('/home/caiwuAdmin/yewu1')">咸豆冻结记录</div>
        <div :class="{active:type===0&&twoNav===1}" @click="toInfo('/home/caiwuAdmin/yewu2')">咸豆扣除记录</div>
        <div :class="{active:type===0&&twoNav===2}" @click="toInfo('/home/caiwuAdmin/yewu3')">佣金发放记录</div>
      </div>
      <div class="nav-item" :class="{active:type===1}" @click="isshow2 = !isshow2" >
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconshenhe"></i>
          </div>
        </div>
        现金账单
      </div>
      <div class="nat-item-two" v-show="type===1 || isshow2">
        <div :class="{active:type===1&&twoNav===0}" @click="toInfo('/home/caiwuAdmin/yewu4')">充值记录</div>
        <div :class="{active:type===1&&twoNav===1}" @click="toInfo('/home/caiwuAdmin/yewu5')">提现记录</div>
      </div>

      <div class="nav-item" :class="{active:type===2}" @click="toInfo('/home/caiwuAdmin/yewu6')" >
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconshenhe"></i>
          </div>
        </div>
        熟人推荐管理
      </div>


    </div>
    <div class="right">
      <router-view @setType="setType"/>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        type: '',
        twoNav: '',
        isshow1: false,
        isshow2: false
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$store.state.topNav = 9
    },
    methods: {
      toInfo(path) {
        this.$router.push(path)
      },
      setType(type, twoNav) {
        this.type = type
        this.twoNav = twoNav
      }
    }
  }
</script>

<style scoped lang="scss">

</style>